import { supabase } from './supabaseClient';

export async function getTasksByChantier(chantierId) {
  const { data, error } = await supabase
    .from('chantier_tasks')
    .select('id, lot_id, status, start_date, target_date')
    .eq('chantier_id', chantierId)
    .is('deleted_at', null);

  if (error) throw error;
  return data || [];
}
